var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmbienceLogoColor60(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0.337891H44.2139V16.124L60 0.337891Z",
    fill: "#E9AA17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 60.3382H11.0641L19.8151 51.5872H36.3902V60.3382H44.2142V16.124L0 60.3382ZM36.3902 43.7632H27.6392L36.3902 35.0121V43.7632Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbienceLogoColor60);
export default __webpack_public_path__ + "static/media/ambience_logo_color_60.d7704bf52c670c4b3d4899392b46f1d4.svg";
export { ForwardRef as ReactComponent };